import { createSlice } from "@reduxjs/toolkit";
import { ActivityMappedData } from "../../Components/Activity/activity";
import { RootState } from "../redux-store";

export interface ReduxStateNotifications {
  items: ActivityMappedData[];
  isLoaded: boolean;
}

const initialState: ReduxStateNotifications = {
  items: [],
  isLoaded: false,
};

const filtersSlice = createSlice({
  name: "notifications",
  initialState,

  reducers: {
    SetNotificationsLoaded: (state, action) => {
      state.isLoaded = action.payload;
    },
    StoreInitialNotificationState: (state, action) => {
      state.items = action.payload;
      console.log("Notifs:StoreInitialState() ok");
    },
    AddNotificationToState: (state, action) => {
      state.items = [action.payload, ...state.items];
    },
  },
});

export const { SetNotificationsLoaded, StoreInitialNotificationState, AddNotificationToState } = filtersSlice.actions;

export const GetNotifications = (state: RootState): ActivityMappedData[] => state.notifications.items;
export const IsLoadedNotifications = (state): boolean => state.notifications.isLoaded;

export default filtersSlice.reducer;
